import React, { useEffect, useState } from "react";
import icons from "../../../assets/images/constantIcons";
import apiService, { formatRupees, handleError } from "../../Common/ApiCommon/ApiService";
import { useNavigate } from "react-router-dom";

const ViewPlayers = ({ isOpen, onClose, booking_id }) => {
  const [PlayersData, setPlayersData] = useState(null);
  const navigate = useNavigate();

  // Fetch players data
  const fetchPlayers = async () => {
    try {
      const response = await apiService.get(`/bookings/${booking_id}`);
      setPlayersData(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };
  useEffect(() => {
    fetchPlayers();
  }, []);

  if (!isOpen || !PlayersData) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-[90%] max-w-lg relative">
        {/* Close Button */}
        <div
          className="absolute top-4 right-4 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
          onClick={onClose}
        >
          <icons.IoClose className="text-green700 text-xl" />
        </div>

        <h2 className="text-xl font-semibold mb-5 text-G500 text-start">
          View Players Details
        </h2>

        {/* Table */}
        <div className="overflow-x-auto h-[60vh] overflow-y-auto horizontalscroll vertical">
          <table className="category-details-table  w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-green700 text-white">
                <th className="border p-2 w-1/2">Field</th>
                <th className="border p-2 w-1/2">Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-2">Table</td>
                <td className="border p-2">{PlayersData.table_name}</td>
              </tr>
              <tr>
                <td className="border p-2">Players</td>
                <td className="border p-2">
                  {PlayersData.players
                    ? PlayersData.players
                      .map((player) => player.name)
                      .join(", ")
                    : "No players available"}
                </td>
              </tr>
              {PlayersData.payable_players.length > 0 && (
                <tr>
                  <td className="border p-2">Payable</td>
                  <td className="border p-2">
                    {PlayersData.payable_players.map((player, index) => (
                      <span
                        key={player.id}
                        className="cursor-pointer hover:text-blue hover:underline"
                        onClick={() =>
                          navigate(`/mainDashboard/customer/viewCustomer/${player.id}`)
                        }
                      >
                        {player.name}
                        {index !== PlayersData.payable_players.length - 1 && ', '}
                      </span>
                    ))}
                  </td>
                </tr>
              )}
              {PlayersData.booking_type && (
                <tr>
                  <td className="border p-2">Shift</td>
                  <td className="border p-2">{PlayersData.booking_type}</td>
                </tr>
              )}
              {PlayersData.date && (
                <tr>
                  <td className="border p-2">Start Date</td>
                  <td className="border p-2">
                    {PlayersData.date.split("T")[0]}
                  </td>
                </tr>
              )}
              {PlayersData.start_time && (
                <tr>
                  <td className="border p-2">Start Time</td>
                  <td className="border p-2">{PlayersData.start_time}</td>
                </tr>
              )}
              {PlayersData.end_date && (
                <tr>
                  <td className="border p-2">End Date</td>
                  <td className="border p-2">
                    {PlayersData.end_date.split("T")[0]}
                  </td>
                </tr>
              )}
              {PlayersData.end_time && (
                <tr>
                  <td className="border p-2">End Time</td>
                  <td className="border p-2">{PlayersData.end_time}</td>
                </tr>
              )}
              {PlayersData.table_charge && (
                <tr>
                  <td className="border p-2">Table Charges</td>
                  <td className="border p-2">₹ {parseFloat(PlayersData.table_charge).toString()}</td>
                </tr>
              )}
              {PlayersData.duration && (
                <tr>
                  <td className="border p-2">Duration</td>
                  <td className="border p-2">{PlayersData.duration}</td>
                </tr>
              )}
              {PlayersData.today_amount && (
                <tr>
                  <td className="border p-2">Today Amount</td>
                  <td className="border p-2">
                    {formatRupees(PlayersData.today_amount)}
                  </td>
                </tr>
              )}
              {PlayersData.discount && (
                <tr>
                  <td className="border p-2">Discount</td>
                  <td className="border p-2">
                    {formatRupees(PlayersData.discount)}
                  </td>
                </tr>
              )}
              {PlayersData.total_amount && (
                <tr>
                  <td className="border p-2">Due Amount</td>
                  <td className="border p-2">
                    {formatRupees(PlayersData.total_amount)}
                  </td>
                </tr>
              )}
              {PlayersData.amount_to_be_pay && (
                <tr>
                  <td className="border p-2">Amount to be Paid</td>
                  <td className="border p-2">
                    {formatRupees(PlayersData.amount_to_be_pay)}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Close Button */}
        <div className="flex justify-end space-x-4 pt-6">
          <button
            type="button"
            onClick={onClose}
            className="py-2 px-4 text-sm bg-white text-green rounded-lg border border-green"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewPlayers;